import { render, staticRenderFns } from "./GeneralFigures.vue?vue&type=template&id=4d671206"
import script from "./GeneralFigures.vue?vue&type=script&lang=js"
export * from "./GeneralFigures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports